<h2 mat-dialog-title>Copy Stipend Configuration</h2>
<mat-dialog-content class="mat-typography">
  <div class="container">
    <p class="text-muted">
      Copies all configuration values from the source year into the target year. If the target year
      already has a configuration, it will be overwritten.
    </p>
    <app-form-builder [formFields]="formFields" [(formGroup)]="userForm"></app-form-builder>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="submitting">Cancel</button>
  <button mat-raised-button color="primary" (click)="submit()" [disabled]="!userForm.valid || submitting">
    {{ submitting ? 'Copying...' : 'Copy' }}
  </button>
</mat-dialog-actions>
